module.exports = __webpack_public_path__ + "static/media/honda-red-bike.029c61d1.jpeg";